module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/media/opponent-paul-felder-desktop.d801ac24.mp4";